import { render, staticRenderFns } from "./SupportCalls.vue?vue&type=template&id=7f3ad180"
import script from "./SupportCalls.vue?vue&type=script&lang=js"
export * from "./SupportCalls.vue?vue&type=script&lang=js"
import style0 from "./SupportCalls.vue?vue&type=style&index=0&id=7f3ad180&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports